/**
 * 标签分类
 */
import { LABELCLASSIFICATION } from '../types';

export default {
    name: `${LABELCLASSIFICATION}`,
    path: '/labelClassification',
    component: () => import(/* webpackChunkName: 'labelClassification' */ '@/views/labelClassification/'),
    redirect: { name: `${LABELCLASSIFICATION}Index` },
    meta: {
        title: '标签分类',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${LABELCLASSIFICATION}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'labelClassification' */ '@/views/labelClassification/home/Home.vue'),
        },

        // 二级页面示例, 没有二级页面就直接删掉
        // {
        //     name: `${LABELCLASSIFICATION}Detail`,
        //     path: 'detail',
        //     component: () => import(/* webpackChunkName: 'labelClassification' */ '@/views/labelClassification/detail/Detail.vue'),
        // },
    ],
};
